const bus = (() => {
  const subs = new Map();

  function subscribe(eventName, cb) {
    if (!subs.has(eventName)) subs.set(eventName, new Set());
    subs.get(eventName).add(cb);
    return () => subs.get(eventName).delete(cb);
  }

  function publish(eventName, data) {
    const set = subs.get(eventName);
    if (!set || set.size === 0) return;
    const handlers = Array.from(set);
    handlers.forEach((handler) => handler(data));
  }

  return { subscribe, publish };
})();

class YGImageLoader extends HTMLElement {
  getYGImageLoader () { // TODO: 命名优化
    if (!this.YGImageLoader) {
      this.YGImageLoader = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            const newImg = new Image();
            newImg.onload = () => {
              img.src = newImg.src;
              img.removeAttribute('data-src');  // 如果只需要加载一次
              observer.unobserve(img);          // 停止观察该元素
            }
            newImg.src = img.getAttribute('data-src');
          }
        });
      }, {
        rootMargin: "50px", // 预加载距离视口 50px 的图片
      });
    }
    return this.YGImageLoader;
  }
}

class YGVideoLoader extends HTMLElement {
  getYGVideoLoader () {
    if (!this.YGVideoLoader) {
      this.YGVideoLoader = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const video = entry.target;
            const template = video.querySelector('template');
            template && video.appendChild(template.content.cloneNode(true));
            
            observer.unobserve(video);
          }
        });
      }, {
        rootMargin: "50px", // 预加载距离视口 50px 的图片
      });
    }
    return this.YGVideoLoader;
  }
}
class YGUtils extends HTMLElement {

}

window.YGUtils = YGUtils;

// 添加调试信息
console.log('YGUtils 已加载:', window.YGUtils);